/* eslint-disable max-len */
import React from 'react';
const defaultContextValue = {
    error: undefined,
    isLoading: false,
    logout: async () => { },
    loginWithRedirect: async () => { },
    isAuthenticated: false,
    getAccessToken: async () => '',
    accessToken: null,
    decodedToken: null,
    tokenError: null,
    withAuthenticationRequired: (Component) => Component,
};
const AuthContext = React.createContext(defaultContextValue);
export default AuthContext;
//# sourceMappingURL=auth-context.js.map